import CleaningZone from "../rooms/cleaning-zone";
import Gate, { GateSet } from "../rooms/gate";
import Landmark from "../rooms/landmark";
import RedZone from "../rooms/red-zone";
import RuleZone from "../rooms/rule-zone";
import TeachAndRepeatZonePath from "../rooms/teach-and-repeat-zone-path";
import { WaypointEdge, WaypointNode } from "../rooms/waypoints";

export enum MapHistoryAction {
  Created,
  Patched,
  Deleted,
}

export enum MapHistoryType {
  RedZone,
  CleaningZone,
  RuleZone,
  TeachAndRepeatZonePath,
  WaypointSet,
  Landmark,
  Gate,
}

export type ChangedDataType =
  | Partial<CleaningZone>
  | Partial<TeachAndRepeatZonePath>
  | Partial<RedZone>
  | Partial<RuleZone>
  | Partial<WaypointNode>
  | { nodes: WaypointNode[]; edges: WaypointEdge[] }
  | Partial<Landmark>
  | ({ gate: Gate } & Partial<Omit<GateSet, "gate">>)

interface MapHistoryEntry {
  action: MapHistoryAction;
  type: MapHistoryType;
  changedData: ChangedDataType;
  additionalChangedData?: TeachAndRepeatZonePath
}

export default MapHistoryEntry;

export const isHistoryLandmark = (data: ChangedDataType): data is Landmark => {
  return "id" in data && "landmarkPoint" in data;
};

export const isHistoryCleaningZone = (data: ChangedDataType): data is CleaningZone => {
  return "id" in data && ("startPosition" in data || "cleaningConfiguration" in data || "points" in data);
};

export const isHistoryRedZone = (data: ChangedDataType): data is RedZone => {
  return "id" in data && "points" in data;
};

export const isHistoryRuleZone = (data: ChangedDataType): data is RuleZone => {
  return "id" in data && ("points" in data || "mapRulesConfiguration" in data);
};

export const isHistoryGateSet = (data: ChangedDataType): data is ({ gate: Gate } & Partial<Omit<GateSet, "gate">>) => {
  return "gate" in data;
}

export const isHistoryTeachAndRepeatZonePath = (data: ChangedDataType): data is TeachAndRepeatZonePath => {
  return ("id" in data || "zoneId" in data) && ("path" in data || "resolveConfiguration" in data || "allowed Deviation" in data)
};

export const isHistoryWaypointNode = (data: ChangedDataType): data is WaypointNode => {
  return "id" in data && "point" in data;
};

export const isHistoryWaypointSet = (
  data: ChangedDataType
): data is { nodes: WaypointNode[]; edges: WaypointEdge[] } => {
  return "nodes" in data && "edges" in data;
};